<template>
  <div class="content">
    <div style="display: flex;justify-content: space-around;align-items: center;font-size: 30px;font-weight: bolder;">
      <el-image
      style="height: 30px"
      :src="QWImage"
      fit="fit"></el-image>
      <i class="el-icon-right"></i>
      <el-image
      style="height: 30px"
      :src="ECImage"
      fit="fit"></el-image>
    </div>
		<div class="formbiox">
      <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm" :rules="rules">
        <el-form-item label="客户名称" prop="name" placeholder="EC客户名称">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile" v-if="mobileOptions.length>0">
          <el-select v-model="ruleForm.mobile" placeholder="请选择手机号">
            <el-option
              v-for="item in mobileOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile" v-else>
          <el-input v-model="ruleForm.mobile"></el-input>
        </el-form-item>
        <el-form-item label="你的EC账号" prop="account">
          <el-input v-model="ruleForm.account" placeholder="你的EC手机号"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" :rows="5" :maxlength="150" v-model="ruleForm.remark"></el-input>
        </el-form-item>
        <div style="width: 100%;display: flex;margin-bottom: 22px;">
          <div style="width: 100px;color: 606266;text-align: right;font-size: 14px;line-height: 40px;padding-right: 12px;">标签</div>
          <div style="flex: 1;display: flex;flex-wrap: wrap;">
            <el-tag style="margin: 10px 5px;" v-for="(tag, index) in tags" :key="index">{{ tag }}</el-tag>
          </div>
        </div>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">立即导入</el-button>
          <el-button type="info" @click="goback()">返回</el-button>
        </el-form-item>
        
      </el-form>
		</div>
	</div>
</template>

<script>
import {UserInfoByUserId, QwExportEc } from '@/api/signature';
import * as ww from '@wecom/jssdk'; 
export default {
  name: 'HomePage',
  data () {
    return {
      ECImage:require('@/assets/EClogo.png'),
      QWImage:require('@/assets/QWlogo.png'),
      userinfo:{},
      customerId:'',
      mobileOptions:[],
      tags:[],
      ruleForm:{
        name:'',
        mobile:'',
        account:'',
        remark:''
      },
      rules: {
          name: [
            { required: true, message: '请输入客户名称', trigger: 'blur' }
          ],
          mobile: [
            { required: true, message: '请选择客户手机号', trigger: 'change' }
          ],
          account: [
            { required: true, message: '请输入你的EC账号', trigger: 'blur' }
          ]
        }
    }
  },
  mounted () {
    this.getCustomerInfo()
  },
  methods: {
    //获取客户的详细信息
    getCustomerInfo(){
      let that = this;
      ww.getCurExternalContact({
        success(res) {
          //获取客户信息
          that.getUserInfoByUserId(res.userId)
          
        },
        fail(err) {
          console.log('getCurExternalContact==>',err);
        }
      })
    },
    async getUserInfoByUserId(customerId) {
      try {
        let userId = localStorage.getItem('userId');
        if(userId){
          let res = await UserInfoByUserId({ userId: userId,customerId:customerId });
          if(res.data.code==200){
            this.userInfo = res.data.userInfo;
            this.customerId = customerId;
            let tags = this.userInfo.tags;
            let arrs = [];
            tags.forEach(element => {
              arrs.push(element.tag_name)
            });
            this.mobileOptions = this.userInfo.remark_mobiles;
            this.tags = arrs;
            this.ruleForm.name = this.userInfo.remark;
            this.ruleForm.mobile = this.userInfo.remark_mobiles[0];
            this.ruleForm.remark = this.userInfo.description;
            this.ruleForm.account = localStorage.getItem('account');
          }else{
            this.$notify({
              title: '错误',
              message: res.data.msg,
              type: 'warning',
              duration: 1000
            })
          }
        }else{
          this.$notify({
            title: '提示',
            message: '授权失败请5分钟后刷新重试',
            type: 'warning',
            duration: 1000
          })
          window.location.href = location.origin
        }
      } catch (error) {
        console.error('获取客户信息失败:', error);
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate( async (valid) => {
        if (valid) {
          let data = {
            name: this.ruleForm.name,
            mobile: this.ruleForm.mobile,
            account: this.ruleForm.account,
            remark: this.ruleForm.remark,
            tags: this.tags,
            userId: localStorage.getItem('userId'),
            customerId:this.customerId
          }
          let res = await QwExportEc(data);
          if(res.data.code==200){
            localStorage.setItem('account',this.ruleForm.account)
            this.$notify({
              title: '成功',
              message: res.data.msg,
              type: 'success',
              duration: 1000
            })
          }else{
            this.$notify({
              title: '失败',
              message: res.data.msg,
              type: 'error',
              duration: 1000
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    goback(){
      this.$router.go(-1);
    }
    
  }
}
</script>

<style scoped>
.content {
		
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
    padding: 20px 0;
	}

.formbiox {
  width: 300px;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title {
  word-wrap: break-word;
  font-size: 36rpx;
  color: #8f8f94;
}
</style>
